import styled, { css } from "styled-components";
import backgroundVertical from "../../assets/paymentLogos/others/background-vertical.png";
import background from "../../assets/paymentLogos/others/background.png";
import failure from "../../assets/paymentLogos/others/failure.png";
import success from "../../assets/paymentLogos/others/success.png";
export const GRID_WRAPPER = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	backdrop-filter: blur(15px);

	@media (min-width: 768px) {
		gap: 15px;
		flex-direction: row;
		flex-wrap: wrap;
		padding: 10px;

		${({ isSub }) =>
			isSub &&
			css`
				padding: 0;
			`}
	}

	@media (min-width: 1024px) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: auto;
		gap: 20px;
		width: 100%;
		padding: 0;
	}

	@media (min-width: 1280px) {
		grid-template-columns: repeat(5, 1fr);
	}
`;

export const Value = styled.div`
	display: flex;
	color: #eff0f6;
	font-size: 18px;
	font-weight: 300;
	line-height: 20px;

	@media (min-width: 768px) {
		font-size: 24px;
	}

	@media (min-width: 1024px) {
		color: #a0a3bd;
		font-size: 26px;
		font-weight: 300;
		line-height: 36px;
	}
`;

export const MinOrMax = styled.div`
	display: flex;
	color: #eff0f6;
	font-size: 9px;
	font-weight: 400;
	line-height: 14px;
	letter-spacing: 0.25px;

	@media (min-width: 1024px) {
		font-size: 12px;
		line-height: 28px;
		letter-spacing: 0.75px;
		color: #a0a3bd;
	}
`;

export const WithdrawNameDesktop = styled.div`
	display: none;

	@media (min-width: 1024px) {
		display: flex;
		color: #a0a3bd;
		font-size: 14px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.75px;
	}
`;

export const WithdrawNameFeaturesWrapper = styled.div`
	color: #a0a3bd;
	font-size: 10px;
	font-weight: 700;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 16px;
	}

	@media (min-width: 1024px) {
		font-size: 14px;
		font-weight: 600;
		line-height: 16px;
		letter-spacing: 0.3px;
	}
`;

export const WithdrawButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 0 5px;
	min-width: 40px;
	background: var(--payment-gradient);
	${(props) =>
		props.isHover &&
		css`
			scale: 1.1;
		`}

	@media (min-width: 768px) {
		padding: 0 10px;
		min-width: 50px;
	}

	@media (min-width: 1024px) {
		border-radius: 20px;
		width: 100%;
		height: 40px;
		background: var(--payment-gradient);
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			@media (min-width: 1024px) {
				border-radius: 10px;
			}

			svg {
				rect,
				path {
					stroke: #e2e2e2;
				}
			}
		`}
`;

export const MinMaxWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		min-height: 106px;
		padding: 10px;
		align-items: flex-start;
		gap: 10px;
		align-self: stretch;
		background: var(--payment-modal-center-bg);
		max-height: 106px;
	}
`;

export const WithdrawItem = styled.div`
		display: flex;
		height: 90px;
		width: 100%;
		min-height: 90px;
		overflow: hidden;
		border-radius: 20px;
		background: var(--payment-modal-bg);
		.bank-img {
			filter: brightness(0) invert(1);
		}
		.no-filter {
			filter: none;
		}
		.w-60 {
			width: 60px;
		}

		@media (min-width: 768px) {
			max-width: calc(50% - 7.5px);
			height: 120px;
			min-height: 120px;
		}

		@media (min-width: 1024px) {
			max-width: 100%;
			flex-direction: column;
			height: 100%;
			min-height: 331px;
			height: 331px;
			justify-content: space-between;

			&:hover {
				background: var(--payment-gradient);

				${MinMaxWrapper} {
					background: var(--main-color-dark);
				}
				${WithdrawButton} {
					background: var(--main-gradient);
				}

				${WithdrawNameDesktop},
				${WithdrawNameFeaturesWrapper},
				${Value},
				${MinOrMax} {
					color: #fff;
				}
			}

			${({ isColorful }) =>
				isColorful &&
				css`
					@media (min-width: 1024px) {
						&:hover {
							background: linear-gradient(180deg, #44976b 0%, #050512 100%);
							box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
							backdrop-filter: blur(15px);

							${MinMaxWrapper} {
								background: #0e1812;
							}
							${WithdrawButton} {
								background: var(--main-explosive);
								border-radius: 20px;
							}

							${WithdrawNameDesktop},
							${WithdrawNameFeaturesWrapper},
						${Value},
						${MinOrMax} {
								color: #fff;
							}

							${Text} {
								color: #010101;
							}
						}
					}
				`}

			${() =>
				window.HAS_LESS_BORDER_RADIUS &&
				css`
					border-radius: 10px;
					box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
					backdrop-filter: blur(15px);
					@media (min-width: 1024px) {
						&:hover {
							background: linear-gradient(
								180deg,
								rgba(2, 19, 21, 0.9) 0.62%,
								rgba(12, 49, 55, 0.9) 12.58%,
								rgba(3, 11, 17, 0.9) 100%
							);
							box-shadow: 0px 1px 10px 0px #0b2a2f;
							backdrop-filter: blur(15px);
							border: 1px solid #0b2a30;

							${MinMaxWrapper} {
								background: #0e1812;
							}
							${WithdrawButton} {
								border-radius: 10px;
								border: 1px solid #fff;
								background: linear-gradient(96deg, #ececfb 13.8%, #eaeaf2 86.14%);
							}

							${WithdrawNameDesktop},
							${WithdrawNameFeaturesWrapper},
						${Value},
						${MinOrMax} {
								color: #fff;
							}

							${Text} {
								color: #010101;
							}
						}
					}
				`}
		}
	`,
	WithdrawMinMax = styled.div`
		display: flex;
		flex-direction: column;

		@media (min-width: 1024px) {
			justify-content: center;
		}
	`,
	WithdrawNameMobile = styled.div`
		color: #a0a3bd;
		font-size: 9px;
		font-weight: 400;
		line-height: 11px;
		letter-spacing: 0.25px;
		align-self: stretch;
		display: flex;
		max-width: 100px;
		min-width: 90px;
		min-height: max-content;

		@media (min-width: 1024px) {
			display: none;
		}
	`,
	Warning = styled.div`
		font-size: 10px;
		padding-top: 5px;
	`;

export const Text = styled.div`
	display: none;
	@media (min-width: 1024px) {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}
`;
export const Icon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	@media (min-width: 1024px) {
		display: none;
	}
`;

export const WithdrawLogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 115px;
	min-width: 115px;
	flex-direction: column;
	height: 90px;
	padding: 10px 5px 10px 10px;

	@media (min-width: 375px) {
		max-width: 130px;
		min-width: 130px;
	}

	@media (min-width: 1024px) {
		max-width: 100%;
		min-width: 100%;
		padding: 0;
	}

	img {
		width: 95px;
		height: auto;

		@media (min-width: 768px) {
			width: 115px;
			height: auto;
		}

		@media (min-width: 1024px) {
			width: 152px;
			height: 50px;
		}
	}

	@media (min-width: 768px) {
		height: 120px;
	}

	@media (min-width: 1024px) {
		height: 85px;
	}
`;

export const ImgWrapper = styled.div`
	display: flex;
	width: 100%;
	padding: 0 15px 0 0;
	height: calc(100% - 22px);
	align-items: center;

	@media (min-width: 1024px) {
		padding: 0;
		justify-content: center;
		height: 85px;
	}
`;
export const WithdrawContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	align-items: flex-start;
	border-top-left-radius: 20px;
	border-bottom-left-radius: 20px;
	overflow-y: auto;
	overflow-x: hidden;
	gap: 5px;
	background: linear-gradient(180deg, #262338 0%, rgba(5, 5, 18, 0) 100%);
	padding: 10px;

	@media (min-width: 768px) {
		overflow: unset;
	}

	@media (min-width: 1024px) {
		background: transparent;
		padding: 0;
		gap: 0;
	}

	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			background: #051b1f;
		`}
`;

export const WithdrawValueWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 3px;
	flex-wrap: wrap;

	@media (min-width: 1024px) {
		gap: 0;
	}
`;

export const WithdrawNameWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		display: flex;
		height: 100px;
		padding: 10px 15px;
		flex-direction: column;
		align-items: flex-start;
		gap: 5px;
		align-self: stretch;
	}
`;

export const DepositItem = styled.div`
		height: 260px;
		overflow: hidden;
		background-color: #d4d6da;
		padding-top: 30px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		&:hover {
			background-color: var(--main-color);
		}
	`,
	DepositLogoWrapper = styled.div`
		padding-bottom: 29px;
		padding-inline-start: 18px;
		& img {
			height: 21px;
		}
	`,
	DepositMinMax = styled.div`
		background-color: #e9ebef;
		padding: 14px 0px 12px 15px;
		height: 70px;
		font-size: 27px;
		font-weight: 300;
		color: #545454;
		line-height: 22px;
		display: flex;
		flex-direction: column;
	`,
	DepositName = styled.div`
		line-height: 14px;
		font-size: 11px;
		color: #000000;
		padding-inline-start: 15px;
		padding-top: 9px;
	`,
	DepositFeature = styled.div`
		line-height: 14px;
		font-size: 11px;
		color: #000000;
		padding-inline-start: 15px;
		font-weight: 700;
	`,
	DepositButton = styled.div`
		line-height: 40px;
		background-color: #000000;
		font-size: 11px;
		font-weight: 600;
		text-align: center;
		margin-top: 9px;
		color: #ffffff;
	`,
	PaymentWrapper = styled.div`
		display: flex;
		flex-direction: column;
	`,
	PaymentImg = styled.div`
		background: url(${backgroundVertical}) no-repeat;
		background-size: 428px;
		background-position-x: center;
		background-position-y: bottom;
		grid-area: image;
		@media (min-width: 428px) {
			background-size: 768px;
		}
		@media (min-width: 768px) {
			background-size: cover;
		}
		@media (min-width: 1024px) {
			position: relative;
			&::before {
				content: " ";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: url(${background}) no-repeat;
				background-size: 150px;
				z-index: 1;
			}
			&::after {
				content: " ";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(to right, #e89200, #eea300);
				z-index: 0;
			}
		}
	`,
	Page = styled.div`
		display: flex;
		flex-direction: column;
		gap: 10px;
	`,
	Title = styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	`,
	Logo = styled.img`
		width: 120px;
		filter: brightness(0) invert(1);
	`,
	FeatureTitleBox = styled.div`
		text-align: end;
		align-items: flex-end;
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-wrap: wrap;
	`,
	Feature = styled.div`
		color: #eff0f6;
		font-size: 9px;
		font-weight: 400;
		line-height: 11px;
		letter-spacing: 0.25px;

		@media (min-width: 1024px) {
			font-size: 12px;
			line-height: 16px;
			letter-spacing: 0.3px;
		}
	`,
	FeatureBankName = styled.div`
		color: #eff0f6;
		text-align: right;
		font-size: 9px;
		font-weight: 600;
		line-height: 11px;
		letter-spacing: 0.25px;
		display: flex;
		flex-wrap: wrap;
		max-width: 100%;

		@media (min-width: 1024px) {
			font-size: 12px;
			font-weight: 700;
			line-height: 16px;
			letter-spacing: 0.3px;
		}
	`,
	Content = styled.div`
		padding: 0px 0px 100px;
		@media (min-width: 728px) {
			min-height: 300px;
		}
	`,
	ContentTitle = styled.div`
		display: flex;
		justify-content: center;
		border-top: 1px solid #4e4b66;
		color: var(--main-explosive-light);
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		padding: 10px 20px;

		${() =>
			window.HAS_LESS_BORDER_RADIUS &&
			css`
				background: #0d2a2e;
				margin-bottom: 10px;
				border: none;
				color: #e2e2e2;
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			`}
	`,
	PaymentContentWrapper = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;

		@media (min-width: 1024px) {
			flex-direction: row;
			gap: 10px;

			& > div {
				width: 50%;
			}
		}
	`,
	Navigation = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		@media (min-width: 1280px) {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			gap: 10px;
			align-items: center;
		}
	`,
	Box = styled.div`
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		gap: 10px;

		${({ hasError }) =>
			hasError &&
			css`
				padding-bottom: 20px;
			`}
	`,
	BoxTitle = styled.div`
		text-align: center;
		display: flex;
		min-width: max-content;
		color: #a0a3bd;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
	`,
	MinMaxInfo = styled.div`
		color: #a0a3bd;
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	`,
	Stake = styled.div`
		color: #545454;
		background-color: #e9ebef;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		font-size: 14px;
		font-weight: 600;
		input {
			font-size: 12px;
			width: 100%;
			line-height: 30px;
			padding-inline-start: 8px;
			outline: none;
			border: 0;
			background: none;
		}
	`,
	BoxWrapper = styled.div`
		@media (min-width: 768px) {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr;
			grid-column-gap: 10px;
		}
	`,
	MaskedInputLabel = styled.label`
		position: absolute;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
		pointer-events: none;
		transition: 0.2s ease all;
		color: #a0a3bd;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.3px;
		${({ isFocused, hasValue }) =>
			(isFocused || hasValue) &&
			css`
				top: 10px;
				border: none;
				outline: none;
				color: #a0a3bd;
				font-size: 10px !important;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			`}
		${({ isFocused, hasValue }) =>
			!isFocused &&
			!hasValue &&
			css`
				height: 100%;
				display: flex;
				align-items: center;
			`}
	`,
	MaskedInput = styled.div`
		position: relative;
		display: flex;
		width: 100%;
		border: none;

		input {
			display: flex;
			height: 40px;
			padding: 0 20px;
			justify-content: space-between;
			align-items: center;
			align-self: stretch;
			width: 100%;
			border-radius: 50px;
			background: var(--modal-input-bg);
			border: none;
			outline: none;
			padding-top: 10px;
			color: #f7f7fc;
			font-size: 12px;
			font-weight: 400;
			line-height: 16px;
			letter-spacing: 0.3px;

			&:focus {
				border: 1px solid var(--main-explosive);
				background: var(--input-bg-has-value);
			}

			&:focus + ${MaskedInputLabel} {
				top: 10px;
				border: none;
				outline: none;
				color: #a0a3bd;
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
			}
		}
	`,
	StakeInput = styled.input`
		display: flex;
		height: 40px;
		padding: 0 20px;
		justify-content: space-between;
		align-items: center;
		align-self: stretch;
		width: 100%;
		border-radius: 50px;
		background: var(--modal-input-bg);
		border: none;
		outline: none;
		color: #f7f7fc;
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.3px;
		width: 100%;
		&::placeholder {
			color: #a0a3bd;
			font-size: 12px;
		}

		${({ hasError }) =>
			hasError &&
			css`
				border: 1px solid red;
			`}
	`,
	ErrorInputWrapper = styled.div`
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: column;
		width: 100%;
		position: relative;
	`,
	StakeInputError = styled.div`
		color: red;
		font-size: 12px;
		position: absolute;
		bottom: -20px;
		left: 20px;
		width: 100%;
	`,
	ResultBox = styled.div`
		padding: 0 20px;
		height: 32px;
		background-color: #d9dbe9;
		color: var(--input-bg-has-value);
		font-weight: 400;
		line-height: 32px;
		display: flex;
		justify-content: space-between;
	`,
	NavigationItem = styled.div`
		opacity: ${(props) =>
			(props.filled && props.filled === true) || props.back || props.close ? "1" : "0.5"};
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		font-size: 12px;
		text-align: center;
		cursor: pointer;
		border-radius: 20px;
		margin-right: 5px;
		margin-left: 5px;

		svg {
			width: 45px;
			height: 45px;
		}
	`,
	ExternalWrapper = styled.div`
		padding-top: 13px;
		display: grid;
		grid-template-rows: 28px 1fr 60px;
		height: 100%;
		grid-row-gap: 9px;
	`,
	ExternalButton = styled.a`
		border-radius: 25px;
		background: linear-gradient(
			180deg,
			var(---first-border-color) 0%,
			var(--secondary-border-color) 100%
		);
		display: flex;
		height: 50px;
		padding: 0 10px;
		justify-content: center;
		align-items: center;
		gap: 5px;
		flex: 1 0 0;
		color: #f7f7fc;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;

		${({ isConfirmButton }) =>
			isConfirmButton &&
			css`
				margin-top: 10px;
			`}
	`,
	Caution = styled.div`
		font-size: 9px;
		font-style: italic;
		line-height: 1.33;
		color: #3d4045;
		padding-left: 10px;
	`,
	ExternalDescription = styled.div`
		color: #f7f7fc;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	`,
	ResultContent = styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	`,
	SuccessImg = styled.div`
		background-image: url(${success});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	FailureImg = styled.div`
		background-image: url(${failure});
		background-size: contain;
		background-repeat: no-repeat;
		width: 52px;
		height: 53px;
	`,
	ResultText = styled.div`
		height: 112px;
		font-size: 30px;
		font-weight: 700;
		line-height: 1.07;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		text-align: center;
	`;
